var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute sidebar-steps bg-white"},[_c('div',[_c('ul',{staticClass:"activity-timeline"},_vm._l((_vm.steps),function(step,index){return _c('li',{key:`step-${index}`,staticClass:"step-cursor"},[_c('div',{key:`timeline-icon-${index}`,staticClass:"timeline-icon",class:step.order == _vm.currentStep
              ? 'bg-primary'
              : step.completed
              ? 'bg-success'
              : 'bg-grey-light',on:{"click":function($event){return _vm.navigateToSelectedStep(step.order)}}},[_c('feather-icon',{attrs:{"icon":step.order == _vm.currentStep
                ? step.icon
                : step.completed
                ? 'CheckIcon'
                : step.icon,"svgClasses":"text-white stroke-current w-5 h-5"}})],1),_c('div',{key:`timeline-info-${index}`,staticClass:"timeline-info mb-20",on:{"click":function($event){return _vm.navigateToSelectedStep(step.order)}}},[_c('p',{staticClass:"font-semibold"},[_vm._v(_vm._s(step.title))])])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }